import React, { useState, useEffect, useRef } from 'react';
import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { withStyles } from '@material-ui/core/styles';
import parse from 'html-react-parser';
import { useSnackbar } from 'notistack';
import queryString from 'query-string';
import MobileDetect from 'mobile-detect';
import { Select, MenuItem, CircularProgress } from '@material-ui/core';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
// import socket from '../../socket/socketConfig';
import interactionPlugin from '@fullcalendar/interaction';
import ProvidersCheckBoxes from './components/ProvidersCheckboxes';
import UncheckedList from './components/UncheckedList';
import CalendarDatePicker from '../../components/CalendarDatePicker';
import AvailabilityModal from './components/AvailabilityModal';
import AppointmentModal from './components/AppointmentModal';
import ProviderToolTip from './components/Tooltips';
import MenuIcon from '@material-ui/icons/Menu';

import './styles.scss';
import './styles.css';
//import './components/daystyle.css';

import {
  transformAppointmentToFullCalendarEvent,
  transformAvailabilityToFullCalendarEvent,
  dateTransform,
  transformToServerEvent,
} from './utils';
import {
  fetchAdminAvailability,
  createAvailability,
  deleteAvailability,
  cancelAppointmentFromAdmin,
} from '../../services/api/admin';
import {
  fetchCurrentPractice,
  fetchCurrentUser,
} from '../../services/api/auth';
import {
  fetchProviderAppointments,
  removeDependentInDateBook,
  fetchFullProviderDateBook,
  createProviderViewDateBookList,
  fetchAllZipCodes,
} from '../../services/api';

function DayView(props) {
  const {
    location,
    history,
    classes: { mainWrapper, main, mainLoading },
  } = props;

  //Auto-refresh fetchAdminAvailability and fetchAppointments using Socket.io
  // const socketUpdate = data => {
  //   console.log('two-dayview--Ids', data.id, currentUserId && currentUserId.id);
  //   if (data.id === currentUserId.id) {
  //     if (data.message === 'auto-refresh-Availability') {
  //       return fetchAvailabilities();
  //     } else {
  //       intialCall();
  //       return fetchAppointments();
  //     }
  //   }
  // };

  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [providersById, setProvidersById] = useState({});
  const [finishedGettingProviders, setFinished] = useState(false);
  const [providerCalRefs, setProviderCalRefs] = useState({});
  const [providerDateBook, setProviderDateBook] = useState({});
  const [filterList, setFilterList] = useState({});
  const [viewableDateRange, setViewableDateRange] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [currentUserId, setCurrentUserId] = useState('');
  const [selectedView, setSelectedView] = useState("Day View");
  /*
  example: {
    <PROVIDER_UUID>: [APPOINTMENT_EVENT, ...],
    ...
  }
   */
  const [appointmentEvents, setAppointmentEvents] = useState({});

  /*
  example: {
    <PROVIDER_UUID>: [AVAILABILITY_EVENT, ...],
    ...
  }
  */
  const [availabilityEvents, setAvailabilityEvents] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [openAvailabilityModal, setOpenAvailabilityModal] = useState(false);
  const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
  const [selectedTenancyType, setSelectedTenancyType] = useState('both');
  const [fetching, setFetching] = useState(true);
  const [selectedZipCode, setSelectedZipCode] = useState('');
  const [allZipCodes, setAllZipCodes] = useState([]);
  const [selectedAvailability, setSelectedAvailability] = useState({
    providerId: '',
    tenancyId: '',
    start: dateTransform(new Date()),
    end: dateTransform(new Date()),
    availability: false,
    scheduleId: '',
    telemedicineId:''
  });
  const [selectedAppt, setSelectedAppt] = useState({
    id: '',
    time: '',
    durationMinutes: 0,
    tenancyLocation: '',
    tenancyId: '',
    patientId: '',
    patientName: '',
    patientDOB: '',
    patientEmail: '',
    patientPhone: '',
    providerFullTitle: '',
  });
  // const [providerId, setProviderId] = useState('');
  const currentLocation = useRef(location.search); //Track url to avoid re-running of the intial function.
  const [withAppointments,setWithAppoinments] = useState([]); // Store providers with appoinments
  const isFetchingRef = useRef(false);

  useEffect(() => {
    (async () => {
      if (fetching) {
        intialCall();
        const user = await fetchCurrentUser();
        setCurrentUserId(user);
        const a = await fetchAllZipCodes(selectedDate);
        setAllZipCodes(a);
        setFetching(false);
      }
    })();
  }, [selectedDate, fetching]);

  //Added the below useEffect to listen for any change in url and make the intial call- Calender bug fix after adding new provider.
  useEffect(()=>{
    if(!currentLocation.current && location.search){
      currentLocation.current= location.search;
      return;
    }
    if(currentLocation.current!== location.search){
      intialCall();
    }
  },[location.search])
  

  const filterListUpdate = data => {
    const sortedFilteredIds = sortAndGroupProviders(data);
    setFilterList(sortedFilteredIds);
  };

  const intialCall = async () => {
    setIsLoading(true);
    let { providers } = await fetchCurrentPractice();
    //Omit folowing providers showing up in calender drop down as per client request.
    const omittedProviders = [
      'b557d646-9d11-472f-abc1-ad7926fe4660',
      '1e9a4b66-eaba-497f-b157-92ddc610d215',
      '5ee221d3-fda0-4d10-be3c-ca0f5f6c634e',
      '05b82538-6fa6-4629-a47a-85867dc1b427',
      '7934814f-abcc-42e7-9eae-f4381bfa60f7',
      '538618e5-3b58-4ed7-aecb-9dca60295cbb',
    ];
    providers = providers.filter(provider => !omittedProviders.includes(provider.id));

    const dateBookList = await fetchFullProviderDateBook(
      selectedDate,
      selectedTenancyType,
      selectedZipCode
    );
    let providerAppoinment = dateBookList.filter(item => item.apptCount>0);
    setWithAppoinments(providerAppoinment);
    if (dateBookList.length === 0) {
      createDateBook(dateBookList, providers);
    }
    const filteredIds = filterSelectOption(providers, dateBookList);

    const sortedFilteredIds = sortAndGroupProviders(filteredIds);

    setFilterList(sortedFilteredIds);
    convertProvidersToIdMap(sortedFilteredIds);
    let urlParams = location.search;
    // Below function is to filrer only provider within user's practice. 
    const ids = new Set(providers.map(obj => obj.id));
    let filteredDateBookList =  dateBookList.filter(obj => ids.has(obj.id));
    if (!urlParams.length && md.mobile()) {
      // const { provider } = await fetchCurrentUser();
      urlParams = setQueryParams([...filteredDateBookList]);
    } else if (!urlParams.length) {
      urlParams = setQueryParams([...filteredDateBookList]);
    }
    const checkedIds = Object.values(queryString.parse(urlParams));
    convertIdsToCalRefMap(checkedIds);
    setFinished(true);
    setIsLoading(false);
    isFetchingRef.current = false;
  };

  /*
   * The viewableDateRange is set for the first time by calendar rendering;
   * the finishedGettingProviders variable is set to true after providersByID
   * is set in the first useEffect. Therefore, the useEffect below circumvents
   * a race condition.
   */
  useEffect(() => {
    (async () => {
      if (viewableDateRange && finishedGettingProviders ) {
        isFetchingRef.current = true;
        // setIsLoading(true);        

        await fetchAppointments();
        await fetchAvailabilities();
        setIsLoading(false);
      }
    })();
  }, [
    viewableDateRange,
    finishedGettingProviders,
    selectedTenancyType,
    selectedZipCode,
  ]);

  const sortAndGroupProviders = (providers) => {
    const priorityGroups = [
      ["Dr Pearl Lui, MD", "Olivia Mannix, PA-C", "Eric Nguyen, PA-C"],
      ["Dr John Meer, MD", "Gaia Mistriel, PA"],
      ["Christine Pipchick, PA", "Suhasini Neelam Satish, PA", "Dr Maria Sequeira, MD"],
      ["Dr. Lovonne Brown, MD", "Emma Poulshock, PA-C", "Dr Zinoviy Gutkovich, MD"]
    ];
    
    // Step 1: Sort everything by name
    const sorted = [...providers].sort((a, b) =>
      a.firstName.localeCompare(b.firstName)
    );
    
    // Step 2: Separate grouped and non-grouped
    const groupedMap = new Map();
    priorityGroups.forEach((group, index) => {
      group.forEach(name => groupedMap.set(name, index));
    });
    const nonGrouped = [];
    const groupedBuckets = priorityGroups.map(() => []);

    sorted.forEach(item => {
      if (groupedMap.has(item.name)) {
        const groupIndex = groupedMap.get(item.name);
        groupedBuckets[groupIndex].push(item);
      } else {
        nonGrouped.push(item);
      }
    });

    const finalResult = [
      ...nonGrouped,
      ...groupedBuckets.flat()
    ];

    return finalResult;
  }
  const createDateBook = (dateBook, providers) => {
    try {
      if (dateBook.length === 0) {
        const size = 2;
        const items = providers?.slice(0, size);
        items.forEach(async provider => {
          const { id } = provider;
          await createAndFetchDateBookedList(id);
        });
      }
    } catch (error) {
      enqueueSnackbar(`oops something went wrong`);
    }
  };

  const filterSelectOption = (totalOpt, selectedOpt) => {
    let filterArr = [];
    let checkedProIdList = [];
    totalOpt.map(async (item, i) => {
      let isExist = selectedOpt.filter(x => x.id === item.id);
      if (isExist > -1) {
        item.isChecked = false;
        item.apptCount = 0;
        item.zipcodeData = [];
        filterArr.push(item);
      } else {
        item.isChecked = true;
        item.apptCount = isExist[0].apptCount;
        item.zipcodeData = isExist[0].zipcodeData;
        checkedProIdList.push(item);
      }
    });
    const finalSelectedArray = [...filterArr, ...checkedProIdList];
    return finalSelectedArray;
  };

  const convertProvidersToIdMap = providers => {
    const providerIdMap = {};
    //setProviderId
    const uniqueId = [];
    providers.map(provider => {
      uniqueId.push(provider.id);
    });
    // setProviderId(uniqueId);
    providers.forEach(provider => {
      const { id } = provider;
      providerIdMap[id] = provider;
    });
    setProvidersById(providerIdMap);
  };

  const convertIdsToCalRefMap = ids => {
    const providerCalendarMap = {};
    ids.forEach(id => {
      providerCalendarMap[id] = React.createRef();
    });
    setProviderCalRefs(providerCalendarMap);
  };

  const setQueryParams = providerDateBook => {
    const queryStr = ['?'];
    for (
      let i = 0;
      // i < Math.min(providers.length, providerDateBook.length);
      i < providerDateBook.length;
      i++
    ) {
      // const { id } = providers[i];
      const { id } = providerDateBook[i];
      if (queryStr.length === 1) {
        queryStr.push(`provider_id_${i + 1}=${id}`);
      } else {
        queryStr.push(`&provider_id_${i + 1}=${id}`);
      }
    }
    history.push({ search: queryStr.join('') });
    return queryStr.join('');
  };

  const getIdsFromUrlParams = (filterVal = null) => {
    const parsed = queryString.parse(location.search);
    const ids = [];
    Object.keys(parsed).forEach(key => {
      if (parsed[key] !== filterVal) ids.push(parsed[key]);
    });
    return ids;
  };

  const md = new MobileDetect(window.navigator.userAgent);
  const checkedProviderIds = getIdsFromUrlParams();
  const firstCheckedProvId = checkedProviderIds[0];
  const firstProvEvents = [
    ...(appointmentEvents[firstCheckedProvId] || []),
    ...(availabilityEvents[firstCheckedProvId] || []),
  ];
  const providerIds = Object.keys(providersById);
  const MAX_CHECKED = 10;

  const fetchAppointments = async (providerId) => {
    try {
      let appointments = {};
      let startOfWeek = moment(viewableDateRange.start)
        .startOf('week')
        .toDate();
      let endOfWeek = moment(viewableDateRange.start)
        .endOf('week')
        .toDate();
      // let startOfWeek = moment(viewableDateRange.start)
      //   .startOf('day')
      //   .toDate();
      // let endOfWeek = moment(viewableDateRange.start)
      //   .add(2, 'day')
      //   .toDate();
      // for (let provider of withAppointments) {
      //   const providerAppointments = await fetchProviderAppointments(
      //     provider.id,
      //     // viewableDateRange.start,
      //     // viewableDateRange.end
      //     startOfWeek,
      //     endOfWeek,
      //     selectedTenancyType,
      //     selectedZipCode
      //   );

      //   const transformedEvents = providerAppointments.map(
      //     transformAppointmentToFullCalendarEvent
      //   );
        
      //   appointments[provider.id] = transformedEvents;
      //   setAppointmentEvents(prev => ({
      //     ...prev,
      //     [provider.id]: transformedEvents,
      //   }));
      // }
      // re-fetch the appointments and availability after update.
      if(providerId){
        // Fetch provider appointments.
        const providerAppointments = await fetchProviderAppointments(
          providerId,
          // viewableDateRange.start,
          // viewableDateRange.end
          startOfWeek,
          endOfWeek,
          selectedTenancyType,
          selectedZipCode
        );

        let transformedEvents = providerAppointments.map(
          transformAppointmentToFullCalendarEvent
        );
        
        appointments[providerId] = transformedEvents;
        setAppointmentEvents(prev => ({
          ...prev,
          [providerId]: transformedEvents,
        }));

        // Fetch availabilities
        let provider = {id: providerId}
      const providerAvailabilities = await fetchAdminAvailability({
        provider,
        dateRange: viewableDateRange,
        tenancyType: selectedTenancyType,
        zipcode: selectedZipCode,
      });

      transformedEvents = providerAvailabilities.map(
        transformAvailabilityToFullCalendarEvent
      );
      setAvailabilityEvents(prev => ({
        ...prev,
        [providerId]: transformedEvents,
      }));
    }
    else{
      for (let provider of withAppointments) {
        const providerAppointments = await fetchProviderAppointments(
          provider.id,
          // viewableDateRange.start,
          // viewableDateRange.end
          startOfWeek,
          endOfWeek,
          selectedTenancyType,
          selectedZipCode
        );

        const transformedEvents = providerAppointments.map(
          transformAppointmentToFullCalendarEvent
        );
        
        appointments[provider.id] = transformedEvents;
        setAppointmentEvents(prev => ({
          ...prev,
          [provider.id]: transformedEvents,
        }));
      }
    }
      // setAppointmentEvents(appointments)
    } catch (err) {
      //todo add err logging here
      enqueueSnackbar('Fetching Booked Appointments failed. Please try again.');
    }
  };

  const fetchAvailabilities = async () => {
    try {
      let availabilities = {};
      for (let id of checkedProviderIds) {
        if (!id) {
          continue;
        }

        const provider = providersById[id];

        if (!provider) {
          continue;
        }

        const providerAvailabilities = await fetchAdminAvailability({
          provider,
          dateRange: viewableDateRange,
          tenancyType: selectedTenancyType,
          zipcode: selectedZipCode,
        });

        const transformedEvents = providerAvailabilities.map(
          transformAvailabilityToFullCalendarEvent
        );

        availabilities[id] = transformedEvents;
        setAvailabilityEvents(prev => ({
          ...prev,
          [id]: transformedEvents,
        }));
      }
    } catch (err) {
      console.error('Error fetching availabilities:', err);
      enqueueSnackbar('Fetching Availability failed. Please try again.');
    }
  };

  /**
   * @param {UUID} id - provider id
   * @param {BOOLEAN} checkedState - are they "checked" / whether to display their schedule
   */
  const toggleCheckbox = async (id, checkedState) => {
    const numChecked = checkedProviderIds.length;
    if (checkedState) {
      createAndFetchDateBookedList(id);
      const parsedQueryStr = queryString.parse(location.search);
      const key = `provider_id_${checkedProviderIds.length + 1}`;
      parsedQueryStr[key] = id;
      history.push({ search: queryString.stringify(parsedQueryStr) });
      setProviderCalRefs({
        ...providerCalRefs,
        [id]: React.createRef(),
      });
    } else if (numChecked === 1)
      enqueueSnackbar(`Minimum 1 schedule at a time.`);
    else {
      removeAndFetchDateBookedList(id);
      const updatedQueryParams = getIdsFromUrlParams(id);
      const queryStr = ['?'];
      for (let i = 0; i < updatedQueryParams.length; i++) {
        const providerId = updatedQueryParams[i];
        if (i > 0) {
          queryStr.push('&');
        }
        queryStr.push(`provider_id_${i + 1}=${providerId}`);
      }
      history.push({ search: queryStr.join('') });
      const updatedProviderCalRefs = { ...providerCalRefs };
      delete updatedProviderCalRefs[id];
      setProviderCalRefs(updatedProviderCalRefs);
    }
  };

  const createAndFetchDateBookedList = async id => {
    try {
      await createProviderViewDateBookList(id);
      //Removed the below call; because it runs before url gets updated. The intialCall is placed inside the useEffect.
      //intialCall();
    } catch (error) {
      enqueueSnackbar(`oops something went wrong`);
    }
  };

  const removeAndFetchDateBookedList = async id => {
    try {
      await removeDependentInDateBook(id);
    } catch (error) {
      enqueueSnackbar(`oops something went wrong`);
    }
  };

  const handleDateChange = date => {
    setSelectedDate(date);
    setFetching(true);
    checkedProviderIds.forEach(id => {
      const ref = providerCalRefs[id];
      const calendarApi = ref?.current.getApi();
      calendarApi.gotoDate(date);
    });
  };

  const calendarAvailabilitySelected = (event, selectedProviderId) => {
    const { extendedProps = {} } = event;
    const { tenancyId = '', providerId = selectedProviderId, scheduleId = '' } = extendedProps;
    setSelectedAvailability({
      ...selectedAvailability,
      start: dateTransform(event.start),
      end: dateTransform(event.end),
      tenancyId,
      providerId,
      scheduleId: scheduleId
    });
    setOpenAvailabilityModal(true);
  };

  const calendarAppointmentSelected = (event, selectedProviderId) => {
    const { extendedProps = {} } = event;
    const {
      tenancyLocation = '',
      tenancyId = '',
      providerFullTitle = '',
      patientId = '',
      patientName = '',
      patientDOB = '',
      patientEmail = '',
      patientPhone = '',
      providerId = selectedProviderId,
    } = extendedProps;

    setSelectedAppt({
      ...selectedAppt,
      time: event.start,
      durationMinutes:
        (new Date(event.end).getTime() - new Date(event.start).getTime()) /
        1000 /
        60,
      id: event.id,
      tenancyLocation,
      providerId,
      tenancyId,
      patientId,
      patientName,
      providerFullTitle,
      patientEmail,
      patientPhone,
      patientDOB,
    });
    setOpenAppointmentModal(true);
  };

  const onCalendarClicked = (info, providerId) => {
    const { event } = info;
    if (event.extendedProps && event.extendedProps.availability) {
      calendarAvailabilitySelected(event, providerId);
    }
    if (event.extendedProps && event.extendedProps.appointment) {
      calendarAppointmentSelected(event, providerId);
    }
  };

  const onSave = async () => {
    // Check user timezone
    const currentUserTimezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (currentUserTimezone !== 'America/New_York') {
      alert(
        '⚠️ Time Zone Mismatch Detected:\n' +
          'Kindly switch your system time zone to "America/New_York, EST" to proceed further.'
      );
      setOpenAvailabilityModal(false);
      return;
    }
    setIsLoading(true);
    try {
      if (
        moment(selectedAvailability.start).isSameOrAfter(
          moment(selectedAvailability.end)
        )
      ) {
        enqueueSnackbar(`Availability 'Start Time' must be before 'End Time.'`);
      } else {
        await createAvailability(transformToServerEvent(selectedAvailability));
        const { providerId } = selectedAvailability;
        // setProviderId(providerId);
        const transformedAvailEvt = transformAvailabilityToFullCalendarEvent(
          selectedAvailability
        );
        const availEvtsList = availabilityEvents[providerId];
        availEvtsList.push(transformedAvailEvt);
        setAvailabilityEvents({
          ...availabilityEvents,
          [providerId]: availEvtsList,
        });
        fetchAppointments(providerId);
        onClose();
        // socket.emit('message', {
        //   message: 'auto-refresh-Availability',
        //   id: currentUserId && currentUserId.id,
        // });
      }
    } catch (err) {
      enqueueSnackbar(`Creating Availability failed. Please try again.`);
    }
    setIsLoading(false);
  };

  const onDelete = async () => {
    setIsLoading(true);
    try {
      await deleteAvailability(transformToServerEvent(selectedAvailability));
      const { providerId } = selectedAvailability;
      const updatedProviderAvailEvts = availabilityEvents[providerId].filter(
        availabilityEvent => {
          return (
            JSON.stringify(availabilityEvent) !==
            JSON.stringify(selectedAvailability)
          );
        }
      );
      setAvailabilityEvents({
        ...availabilityEvents,
        [providerId]: updatedProviderAvailEvts,
      });
      fetchAppointments(providerId);
      onClose();
      // socket.emit('message', {
      //   message: 'auto-refresh-Availability',
      //   id: currentUserId && currentUserId.id,
      // });
    } catch (err) {
      enqueueSnackbar('Deleting Availability failed. Please try again.');
    }
    setIsLoading(false);
  };

  const cancelAppointment = async () => {
    const appointmentId = selectedAppt.id;

    setIsLoading(true);
    try {
      await cancelAppointmentFromAdmin(appointmentId);
      const { providerId } = selectedAppt;
      const updatedProviderApptEvts = appointmentEvents[providerId].filter(
        event => event.id !== appointmentId
      );

      setAppointmentEvents({
        ...appointmentEvents,
        [providerId]: updatedProviderApptEvts,
      });

      onClose();
    } catch (err) {
      enqueueSnackbar('Failed to cancel appointment. Please try again.');
    }
    setIsLoading(false);
  };

  const onClose = () => {
    setSelectedAvailability({
      start: '',
      end: '',
      providerId: '',
      tenancyId: '',
      scheduleId: '',
      telemedicineId:''
    });
    setSelectedAppt({
      start: '',
      end: '',
      tenancyLocation: '',
      tenancyId: '',
      patientId: '',
      patientName: '',
      providerFullTitle: '',
      patientDOB: '',
      patientEmail: '',
      patientPhone: '',
    });
    setOpenAvailabilityModal(false);
    setOpenAppointmentModal(false);
  };

  const onTimeChange = (type, time) => {
    const dateTime = moment(time);
    setSelectedAvailability({
      ...selectedAvailability,
      [type]: dateTime.toDate(),
    });
  };

  // telemedicineId is required to generrate telemedicine schedule automatically while creating an in-person schedule
  const onTenancyChange = (tenancyId,telemedicineId) => {
    setSelectedAvailability({
      ...selectedAvailability,
      tenancyId,
      telemedicineId
    });
  };

  const showToggle = () => {
    setToggle(!toggle);
    if (toggle === true) {
      const get = document.getElementById('menu-bar');
      get.style.display = 'block';
      document.getElementById('contentBox').style.width = 'calc(100% - 255px)';
    } else {
      const get = document.getElementById('menu-bar');
      get.style.display = 'none';
      document.getElementById('contentBox').style.width = '100%';
    }
  };

  const handleChangeTenancyType = event => {
    const value = event.target.value;
    setSelectedZipCode('');
    setSelectedTenancyType(value);
    setFetching(true);
  };

  const handleZipChange = event => {
    const value = event.target.value;
    setSelectedZipCode(value);
    setFetching(true);
  };


  return isLoading ? (
    <div className={mainWrapper}>
      <div className={mainLoading}>
        <Select className="menu-button" value="Day View">
          <MenuItem
            component={Link}
            to="/admin/schedule/weekview"
            value="Week View"
            
          >
            Week View
          </MenuItem>
          <MenuItem
            component={Link}
            to="/admin/schedule/dayview"
            value="Day View"
          >
            Day View
          </MenuItem>
        </Select>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <CircularProgress size="90px" />
        </div>
      </div>
    </div>
  ) : (
    <div className={mainWrapper}>
      <div className={main}>
        <div className="toogle-bar" onClick={showToggle}>
          <MenuIcon />
        </div>
        <div className="menu-bar">
          <Select className="menu-button"  value={selectedView}
             onChange={(e)=>setSelectedView(e.target.value)}>
            <MenuItem
              component={Link}
              to="/admin/schedule/weekview"
              value="Week View"
              // disabled={selectedView === "Week View"}
              style={{
                backgroundColor: selectedView === "Day View" ? "white" : "none",
              }}
            >
              Week View
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/schedule/dayview"
              value="Day View"
              disabled={selectedView === "Day View"}
              style={{
                backgroundColor: selectedView === "Week View" ? "white" : "transparent",
                color: selectedView === "Day View" ? "black" : "transparent",
                opacity: selectedView === "Day View" ? "0.4" : "1",
                cursor: selectedView === "Day View" ? "not-allowed" : "none",
              }}
            >
            
              Day View
            </MenuItem>
          </Select>
          <Select
            className="menu-button"
            value={selectedTenancyType}
            onChange={handleChangeTenancyType}
          >
            <MenuItem value="both">Both</MenuItem>
            <MenuItem value="inPerson">InPerson</MenuItem>
            <MenuItem value="telemedicine">Telemedicine</MenuItem>
          </Select>

          <Select
            className={`menu-button `}
            value={selectedZipCode || ''} // Set to empty string when no zip code is selected
            onChange={handleZipChange}
            displayEmpty
            disabled={selectedTenancyType == 'telemedicine'}
            sx={{
              cursor:
                selectedTenancyType === 'telemedicine'
                  ? 'not-allowed'
                  : 'pointer',
              // opacity: selectedTenancyType === 'telemedicine' ? 0.5 : 1,
              '&.Mui-disabled': {
                cursor: 'not-allowed',
              },
            }}
          >
            <MenuItem value="">
              <em>Search by zipcode</em> {/* Placeholder text */}
            </MenuItem>
            {allZipCodes.map((zip, index) => (
              <MenuItem key={index} value={zip}>
                {zip}
              </MenuItem>
            ))}
          </Select>

          {checkedProviderIds.length < providerIds.length && (
            <UncheckedList
              providerIds={providerIds}
              filterList={filterList}
              providerCalRefs={providerCalRefs}
              providersById={providersById}
              toggleCheckbox={toggleCheckbox}
              filterListUpdate={data => filterListUpdate(data)}
            />
          )}
        </div>
        <ProvidersCheckBoxes
          MAX_CHECKED={MAX_CHECKED}
          toggleCheckbox={toggleCheckbox}
          filterList={filterList}
          selectedDate={selectedDate}
          // checkedProviderIds={providerId}
          checkedProviderIds={checkedProviderIds}
          providerCalRefs={providerCalRefs}
          providersById={providersById}
          filterListUpdate={data => filterListUpdate(data)}
        />
        <CalendarDatePicker
          selectedDate={selectedDate}
          handleDateChange={handleDateChange}
          autoOk={true}
          label="Select a date"
        />
        <div className="main-div-calendar">
          {/* <div className="providers-title-container">
            {checkedProviderIds.map((id,i) => {
              if (providersById[id]) {
                const provider = providersById[id];
                return (
                  <ProviderToolTip
                    key={`title-${id}`}
                    title={provider && provider.name}
                  >
                    <div className="provider-title" style={{paddingLeft:i===0?'5px':'0', width:i===0?'127px':'' }}>
                    {provider && provider.name.slice(0, 16) + "..."}
                    </div>
                  </ProviderToolTip>
                );
              }
              return null;
            })}
          </div> */}

          {/* Moved the providers-title-container below the following calender div and removed the inline styles */}
          <div>
            {/* <div className="providers-title-container" >
            {checkedProviderIds.map((id,i) => {
              
              if (providersById[id]) {
                const provider = providersById[id];
                return (
                  <ProviderToolTip
                    key={`title-${id}`}
                    title={provider && provider.name}
                  >
                    <div className="provider-title">
                    {provider && provider.name.slice(0, 16) + "..."}  
                    </div>
                  </ProviderToolTip>
                );
              }
              return null;
            })}
          </div> */}
            <div className="calendars-container custom-calender-view">
              <div className="scheduler-view" key={firstCheckedProvId}>
              <div style={{textAlign: 'center', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '5px 0px 10px 10px', backgroundColor: '#ffbe69'}}>{providersById[firstCheckedProvId].name}</div>
                <FullCalendar
                  ref={providerCalRefs[firstCheckedProvId]}
                  initialDate={selectedDate}
                  selectable
                  timeZone="local"
                  initialView="timeGridDay"
                  select={event => {
                    calendarAvailabilitySelected(event, firstCheckedProvId);
                  }}
                  plugins={[timeGridPlugin, interactionPlugin]}
                  contentHeight="auto"
                  slotMinTime={'06:00:00'}
                  slotMaxTime={'23:00:00'}
                  events={firstProvEvents}
                  allDaySlot={false}
                  headerToolbar={false}
                  slotDuration={'01:00:00'}
                  snapDuration={'00:10:00'}
                  eventClick={event => {
                    onCalendarClicked(event, firstCheckedProvId);
                  }}
                  datesSet={(calEvent) => {
                    const { start, end } = calEvent;
                    setViewableDateRange({ start, end });
                  }}
                  eventContent={info => {
                    const data = info.event.title;
                    return(
                      <>
                        {parse(data)}
                        <div className="day-view">
                          <div className="tooltip">
                            <div>
                              {moment(info.event.start).format('hh:mm') +
                                '- ' +
                                moment(info.event.end).format('hh:mm') +
                                '-' +
                                info.event.title}
                            </div>
                          </div>
                        </div>
                      </>,
                      info.el
                    );
                    // return info.el;
                  }}
                />
              </div>
              {checkedProviderIds.map(providerId => {
                /*
                 * availability/appointment events may or may not yet have the providerId
                 * field initialized yet. Therefore, including " || [] " to save the case
                 * where the code is attempting to spread an object that does not exist yet.
                 */
                if (providerId !== firstCheckedProvId) {
                  const thisProvidersEvents = [
                    ...(appointmentEvents[providerId] || []),
                    ...(availabilityEvents[providerId] || []),
                  ];

                  return (
                    <div className="timeless-view" key={providerId}>
                      <div style={{textAlign: 'center', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '5px 0px 10px 10px', backgroundColor: '#ffbe69'}}>
                        {providersById[providerId].name}
                      </div>
                      <FullCalendar
                        ref={providerCalRefs[providerId]}
                        initialDate={selectedDate}
                        // handleWindowResize={true}
                        selectable
                        timeZone="local"
                        initialView="timeGridDay"
                        // windowResize={handleSize}
                        select={event => {
                          calendarAvailabilitySelected(event, providerId);
                        }}
                        plugins={[timeGridPlugin, interactionPlugin]}
                        // height="100%"
                        contentHeight="auto"
                        slotMinTime={'06:00:00'}
                        slotMaxTime={'23:00:00'}
                        events={thisProvidersEvents}
                        allDaySlot={false}
                        headerToolbar={false}                     
                        slotDuration={'01:00:00'}
                        snapDuration={'00:10:00'}
                        eventClick={event => {
                          onCalendarClicked(event, providerId);
                        }}
                        datesSet={(calEvent) => {
                          const { start, end } = calEvent;
                          setViewableDateRange({ start, end });
                        }}
                        eventContent={info => {
                          const data = info.event.title;
                          return (
                            <>
                              {parse(data)}
                              <div className="day-view">
                                <div className="tooltip">
                                  <div>
                                    {moment(info.event.start).format('hh:mm') +
                                      '- ' +
                                      moment(info.event.end).format('hh:mm') +
                                      '-' +
                                      info.event.title}
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                          
                        }}
                      />
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
        {openAvailabilityModal && (
          <AvailabilityModal
            open={openAvailabilityModal}
            selectedAvailability={selectedAvailability}
            provider={providersById[selectedAvailability.providerId]}
            tenancies={
              (providersById[selectedAvailability.providerId] &&
                providersById[selectedAvailability.providerId].tenancies) ||
              []
            }
            onClose={onClose}
            onSave={onSave}
            onDelete={onDelete}
            onEventStartChange={value => onTimeChange('start', value)}
            onEventEndChange={value => onTimeChange('end', value)}
            onTenancyChange={onTenancyChange}
          />
        )}
        {openAppointmentModal && (
          <AppointmentModal
            open={openAppointmentModal}
            onClose={onClose}
            apptCountUpdate={intialCall}
            currentProvider={providersById[selectedAppt.providerId]}
            selectedAppt={selectedAppt}
            cancelAppointment={cancelAppointment}
            refeshAppointments={fetchAppointments}
            currentUserId={currentUserId.id}
            currentUser={currentUserId}
          />
        )}
      </div>
    </div>
  );
}

const styles = () => ({
  mainWrapper: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'white',
    overflow: 'scroll',
  },
  mainLoading: {
    width: '100%',
    height: '800px',
    padding: '2rem 2rem',
    display: 'flex',
    alignItems: 'center',
  },
  main: {
    width: '100%',
    height: '100%',
    padding: '2rem 2rem',
    paddingBottom: '5px',
    display: 'flex',
    flexDirection: 'column',
  },
  notAllowed: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
});

export default withStyles(styles)(DayView);
